import React, { useRef, useState } from 'react';
//@ts-ignore
import * as styles from './product-display-cards-gallery.module.css';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import CtaLink from '../Global/CtaLink';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import ShowMoreArrow from '../Global/ShowMoreArrow';
import RichText from '../Global/RichText';
import {
    optimizeKontentImageUrl,
    buildKontentSrcSet,
    imagePreset,
} from '../Global/DataUtils';

interface Props {
    noOfCardsToDisplayOnMobile?: number;
    headlineText?: string;
    modifiedProducts?: any;
    revealMoreText?: string;
}

export const ProductCardsStackView: React.FC<Props> = ({
    noOfCardsToDisplayOnMobile,
    headlineText,
    modifiedProducts,
    revealMoreText,
}) => {
    const wrapperRef = useRef(null);
    const breakpoints = useBreakpoint();
    const [showAll, setShowAll] = useState(
        noOfCardsToDisplayOnMobile && !breakpoints.sm ? false : true
    );
    const toggleShowAll = () => {
        setShowAll((prevShowAll) => !prevShowAll);
    };

    return (
        <>
            <div className={styles.wrapper} ref={wrapperRef}>
                {headlineText && (
                    <div className={styles.headline}>
                        <h3>{headlineText}</h3>
                    </div>
                )}
                {modifiedProducts.value.length &&
                    modifiedProducts.value
                        .slice(
                            0,
                            breakpoints.sm || (showAll && !breakpoints.sm)
                                ? modifiedProducts.value.length
                                : noOfCardsToDisplayOnMobile
                        )
                        .map((card, idx) => {
                            return (
                                <div className={styles.cardWrapper} key={idx}>
                                    <div className={styles.card}>
                                        <div className={styles.cardInner}>
                                            {card.badgeText && (
                                                <div className={styles.badge}>
                                                    <p
                                                        style={{
                                                            background:
                                                                card?.badgeBackgroundColor
                                                                    ? card?.badgeBackgroundColor
                                                                    : '#f06623',
                                                            color: card.badgeTextColor
                                                                ? card.badgeTextColor
                                                                : 'white',
                                                        }}
                                                    >
                                                        {card?.badgeText}
                                                    </p>
                                                </div>
                                            )}
                                            {card.productImg?.url && (
                                                <img
                                                    src={optimizeKontentImageUrl(
                                                        card.productImg.url,
                                                        {
                                                            ...imagePreset.card
                                                                .desktop,
                                                            q: 95,
                                                        }
                                                    )}
                                                    srcSet={buildKontentSrcSet(
                                                        card.productImg.url,
                                                        imagePreset.card.desktop
                                                            .w,
                                                        {
                                                            fm: 'webp' as const,
                                                            q: 95,
                                                        }
                                                    )}
                                                    sizes="(max-width: 576px) 100vw, 50vw"
                                                    alt={
                                                        card.productImg?.name ||
                                                        ''
                                                    }
                                                    loading="lazy"
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                />
                                            )}
                                            {card.productTitle && (
                                                <h4>{card.productTitle}</h4>
                                            )}
                                            {card.productDesc?.value !==
                                                '<p><br></p>' && (
                                                <div
                                                    className={
                                                        styles.description
                                                    }
                                                >
                                                    {RichText(
                                                        card.productDesc,
                                                        undefined,
                                                        undefined,
                                                        undefined,
                                                        'product_description'
                                                    )}
                                                </div>
                                            )}
                                            {card.priceText && (
                                                <p
                                                    style={{
                                                        background:
                                                            card.priceBackgroundColor
                                                                ? card.priceBackgroundColor
                                                                : 'transparent',
                                                        color: card.priceTextColor
                                                            ? card.priceTextColor
                                                            : 'black',
                                                        fontWeight: 'bold',
                                                        padding: '4px 0',
                                                        margin: '0.5rem 0 1rem 0',
                                                    }}
                                                >
                                                    {card.priceText}
                                                </p>
                                            )}
                                            {card.ctaLabel && (
                                                <div className={styles.cta}>
                                                    <CtaLink
                                                        href={
                                                            card?.ctaAnchor
                                                                ? BuildLinkHref(
                                                                      card?.ctaLocation
                                                                  ) +
                                                                  '#' +
                                                                  card?.ctaAnchor
                                                                : BuildLinkHref(
                                                                      card?.ctaLocation
                                                                  )
                                                        }
                                                        target={
                                                            card?.ctaWindowAct
                                                        }
                                                    >
                                                        {card.ctaLabel}
                                                    </CtaLink>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                {noOfCardsToDisplayOnMobile &&
                    modifiedProducts.value.length >
                        noOfCardsToDisplayOnMobile &&
                    !breakpoints.sm && (
                        <>
                            {showAll ? (
                                <div className={styles.showLessArrow}>
                                    <ShowMoreArrow
                                        btnText={''}
                                        strokeColor={'#505251'}
                                        handleClick={() => {
                                            toggleShowAll();
                                            if (wrapperRef.current) {
                                                wrapperRef.current.scrollIntoView(
                                                    {
                                                        behavior: 'instant',
                                                    }
                                                );
                                            }
                                        }}
                                        transform={'0'}
                                    />
                                </div>
                            ) : (
                                <ShowMoreArrow
                                    btnText={revealMoreText || ''}
                                    strokeColor={'#505251'}
                                    handleClick={toggleShowAll}
                                    transform={'0'}
                                />
                            )}
                        </>
                    )}
            </div>
        </>
    );
};
